import { Theme, Typography } from '@mui/material'
import useEmotionStyles from 'hooks/useEmotionStyles'
import { PageName } from 'stores/helpers/Navigation.interface'

const CONTENT_CONTACT_PAGE = '100% kostenlos und Schufa neutral'
const CONTENT_INCOME_PAGE =
  'Fast geschafft! Sie stehen kurz davor, von einer Vielzahl von Banken ein Kreditangebot zu erhalten'

export const getButtonTooltipContent = (
  currentPageInSession: string | null | PageName
): string => {
  if (currentPageInSession === 'contact') {
    return CONTENT_CONTACT_PAGE
  }

  if (currentPageInSession === 'income') {
    return CONTENT_INCOME_PAGE
  }

  return ''
}

interface Props {
  content: string
}

const styles = (theme: Theme) => ({
  container: {
    position: 'relative' as 'relative',
    color: theme.palette.grey[900],
    background: '#F6FDF5', // color not available in theme palette
    border: `1px solid ${theme.palette.success.main}`,
    borderRadius: theme.spacing(0.5),
    padding: theme.spacing(1),
    textAlign: 'center' as 'center',

    '&::after': {
      content: '""',
      position: 'absolute' as 'absolute',
      bottom: theme.spacing(-2),
      left: `calc(${(8 / 12) * 100}%)`, // based on values in getButtonSizesExperiments
      width: theme.spacing(1),
      height: theme.spacing(1),
      borderWidth: theme.spacing(1),
      borderStyle: 'solid',
      borderColor: `${theme.palette.success.main} transparent transparent transparent`,
      transform: 'translateX(-50%)'
    }
  }
})

export const ButtonTooltip: React.FC<Props> = ({ content }) => {
  const { container } = useEmotionStyles(styles)

  if (!content) {
    return null
  }

  return (
    <div className={container}>
      <Typography variant="body2" marginBottom="0">
        {content}
      </Typography>
    </div>
  )
}
